import quickSelectMedian from 'median-quickselect';
import { matrixToArray } from './matrixToArray';
/**
 * returns the median of the matrix
 */
export function matrixMedian(matrix) {
    return quickSelectMedian(matrixToArray(matrix));
}
//# sourceMappingURL=matrixMedian.js.map